import React from 'react';
import "./Loader.css";

export function Loader(props){
  return <section className="loader-container">
    <div className="loader-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    <div className="loader-text-spacer"><h2>{props.children}</h2></div>
    </section>
}